module.exports = __webpack_public_path__ + "img/cfbd332.png";